import { render, staticRenderFns } from "./List.vue?vue&type=template&id=53f2d81e&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/generic-list.css?vue&type=style&index=0&id=53f2d81e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f2d81e",
  null
  
)

export default component.exports